export enum UserRole {
  Guest = "guest",
  Sender = "sender",
  Recipient = "recipient"
}
